const com40 = {
    code: "40",
    length: { min: 2, max: 2 },
    payload: [
        { name: "código", type: "bytes", length: 1, description: "Código de configuración (1 byte).", pad: "00" },
        { name: "num", type: "bytes", length: 1, description: "Número de medidas para publicar (1 byte).", pad: "00" }
    ],
};

export default com40;